
 <div class="main-wrapper">
    <div class="main-content">
            <header>
           
                    <div class="head-line">
                 
                        <p>Dash Board</p>
                    </div>
                <div class="user-wrapper">
                   <p>Skillplex Technologies</p>
                  
                    <div>
                        <img class="log1" src="../../assets/images/Ellipse 2.png">
                    </div>
                </div>
            </header>
            
            <main class="main-2">

               <div class="container">
                <div class="projects">
                        <div class="card1">
                          
                        

                        </div>
                        <div class="col-12 footer-div">
                            <img src="../../assets/images/accruon-logo.png">
                        </div>
                    </div>
                   
            </div>

    
            </main>
   
    </div>
    </div>

     <!-- Code begins here -->
   <!-- <a href="#" class="float" id="float-w">
    <img src="../../../assets/images/whatsapp.svg" class="my-float">
   </a> -->

